import {FC, useEffect, useState} from 'react'
import {Button} from '_core'
import {DateField} from '_core/forms'
import {OrderCard} from 'app/features/orders/componentsv1'
import {useFormik, FormikProvider} from 'formik'
import moment from 'moment'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {
  selectViewOrderDeliveryMethod,
  selectViewOrderFulfillmentStatus,
  selectViewOrderFutureShipDate,
  selectViewOrderPaymentStatus,
} from 'app/features/orders/redux/order/orderSlice'
import {ShipDateInitialState} from './model/FutureShipDateModel'
import {orderFulfillmentStatus, orderStatus} from 'app/features/orders/models'
import {deliveryTypes} from 'app/constant'
import {useParams} from 'react-router-dom'
import ordersService from 'app/services/OrdersService'
import {formatToMDY, formatYMDTimeStamp} from 'app/format/date'
import {showMessage} from 'app/redux/messageSlice'
import {financialStatusTypes} from 'app/utilities'

type Props = {}

const FutureShipDate: FC<Props> = () => {
  const dispatch = useDispatch()
  const {orderId}: any = useParams<any>()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const fulfillmentStatus = useSelector<RootState>(selectViewOrderFulfillmentStatus)
  const viewDM = useSelector<RootState, string | any>(selectViewOrderDeliveryMethod)
  const viewShipDate = useSelector<RootState, string | any>(selectViewOrderFutureShipDate)
  const paymentStatus = useSelector<RootState, string | any>(selectViewOrderPaymentStatus)

  const formik = useFormik({
    initialValues: ShipDateInitialState,
    onSubmit: (values) => {
      handleSubmit(values)
    },
  })
  const {setFieldValue, values, setFieldError} = formik
  const {shipDate} = values
  const validate = () => {
    if (!shipDate) {
      setFieldError('shipDate', 'Ship Date is required')
      return false
    } else {
      setFieldError('shipDate', '')
      return true
    }
  }

  useEffect(() => {
    if (viewShipDate) setFieldValue('shipDate', formatToMDY(viewShipDate), true)
  }, [viewShipDate, setFieldValue])

  const handleSubmit = async (value: any) => {
    if (validate()) {
      try {
        setIsSubmitting(true)
        await ordersService.updateOrderFutureShipDate(orderId, formatYMDTimeStamp(value.shipDate))
        dispatch(
          showMessage({
            text: 'Future ship date has been updated successfully',
            variant: 'success',
          })
        )
        setIsSubmitting(false)
      } catch (error) {
        setIsSubmitting(false)
        console.error('An error occurred while saving future ship date:', error)
        dispatch(
          showMessage({text: 'An error occurred while saving future ship date', variant: 'error'})
        )
      }
    }
  }

  return (
    <>
      {(fulfillmentStatus === orderFulfillmentStatus.unfulfilled ||
        fulfillmentStatus === orderStatus.partialFulfilled) &&
        (paymentStatus === financialStatusTypes.paid ||
          paymentStatus === financialStatusTypes.partiallyRefunded) &&
        viewDM === deliveryTypes.ship && (
          <OrderCard title='Future Ship Date' className='py-6'>
            <div>
              <FormikProvider value={formik}>
                <form onSubmit={formik.handleSubmit}>
                  <div className='d-flex gap-6'>
                    <DateField
                      id='shipDate'
                      name='shipDate'
                      placeholder='Ship Date'
                      minDate={moment().format('MM-DD-YYYY')}
                    />
                    <Button
                      id='btnSubmit'
                      type='submit'
                      title='Save'
                      isSubmitting={isSubmitting}
                      disabled={formatToMDY(viewShipDate) === shipDate}
                      className='btn-primary btn-sm'
                    />
                  </div>
                </form>
              </FormikProvider>
            </div>
          </OrderCard>
        )}
    </>
  )
}

export default FutureShipDate
